import React, { createContext, useState, useEffect } from "react";
import * as apiService from "../services/api.service";
import Loader from "../components/Loader";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as uiActions from '../actions/uiActions';

export const TranslationContext = createContext();
function  TranslationProviderComponent (props) {
    const { children } = props
    const [translation, setTranslation] = useState([]);
    const [translationLoaded, setTranslationLoaded] = useState(false);

    useEffect(() => {
        apiService.getExternal("translations").then((resp) => {
            setTranslation(resp.key_values);
            let messages = []
            let constants = []
            const keys = [
                "config3d_message_toobig_dimensions",
                "config3d_message_copied_description",
                "config3d_message_warning_fetch_data",
                "config3d_message_warning_save_data",
                "config3d_message_warning_veneer_display",
                "config3d_message_warning_layout_baseheight_display",
                "config3d_message_warning_requested_config_display",
                "config3d_message_warning_visual_change_display",
                "config3d_custom_pieces_not_available_granit_msg",
                "config3d_message_warning_fetch_data_not_found"
            ];
            const constantsKeys = [
                "config3d_patternandengravings_modal_reserved_line",
                "config3d_patternandengravings_modal_default_line"
            ]
            keys.forEach(element => {
                const elementValue = resp.key_values.find(key_value => key_value.key === element)
                messages.push({key: element, value: elementValue?.to_local})
                
            });
            constantsKeys.forEach(element => {
                const elementValue = resp.key_values.find(key_value => key_value.key === element)
                constants.push({key: element, value: elementValue?.to_local})
                
            });
            props.uiActions.addMessages(messages)
            props.uiActions.addConstants(constants)
            setTranslationLoaded(true);
        });
    }, []);

    const t = (key) => {
        const translationItem = translation.find((item) => item.key === key);
        return translationItem ? translationItem.to_local : key;
    };

    if (!translationLoaded) {
        return <Loader />;
    }

    return (
        <TranslationContext.Provider value={t}>
            {children}
        </TranslationContext.Provider>
    );
};
export  const TranslationProvider = connect(
   null,
  dispatch => ({
    uiActions: bindActionCreators(uiActions, dispatch),
  }))(TranslationProviderComponent);
